import { render } from "./WatchVideo.vue?vue&type=template&id=72c4e81f"
import script from "./WatchVideo.vue?vue&type=script&lang=js"
export * from "./WatchVideo.vue?vue&type=script&lang=js"
script.render = render

export default script